export enum EnumPackageStatusType {
  Shipping = "Shipping",
  Transit = "In-Transit",
  Delivery = "Delivery",
  Exception = "Exception",
}
